import globalCorporatePartner from './modules/globalCorporatePartner';

export default {
  init() {
  },
  finalize() {
    globalCorporatePartner();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGlobalCorporatePartnerTerms.js